<template>
  <v-app>
 

    <v-toolbar v-if="$store.getters.is_loggedin" app  flat color="primary" dark >
      <v-toolbar-side-icon @click="$refs.menulateral.showHideMenu()"></v-toolbar-side-icon>

      <v-toolbar-title>Nova Música Gospel</v-toolbar-title>

      <v-spacer></v-spacer>
      
     
    </v-toolbar>


    <!--v-if="$store.getters.is_loggedin"-->
   
    
    <v-content >
            <menulateral v-if="$store.getters.is_loggedin" ref="menulateral" />
          <router-view  v-on:showHideMenu="showHideMenu"></router-view>
        
    </v-content>
    
    <!-- move from here -->
    <div class="text-xs-center">
    
    <v-dialog
      v-model="$store.getters.loading"
      
      persistent
      width="300"
    >      <v-card
        color="primary"
        dark
      >
        <v-card-text class="text-xs-center">
          Aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- / mode from here -->
  </v-app>
</template>

<script>
import menulateral from './components/base/menulateral.vue';
export default {
  name: 'App',  
  components: {
    menulateral
  },
  methods:{
    showHideMenu: function(e){
      this.$refs.menulateral.showHideMenu();
    }
  },
  beforeCreate:function(){
    if(!this.$store.getters.is_loggedin){
      this.$router.push('/login');
    }
  },
  created:function(){
    
  }

}
</script>